(function () {
    "use strict";

    const DEFAULT_BUSINESS_OWNERSHIP = 100;

    const MIN_ALLOWED_AGE = 18;

    const MAPPED_FIELD_NAMES = {
        firstName: "first_name",
        lastName: "last_name",
        birthDate: "date_of_birth",
        ssn: "ssn",
        businessOwnership: "ownership_percentage",
        city: "city",
        street: "street_address",
        zip: "zip_code",
        state: "state",
        email: "email",
        phone: "phone_number",
        identificationFrontImageUrl: "identification_front_image_url",
        identificationBackImageUrl: "identification_back_image_url",
        jobTitle: "job_title"
    };

    Controllers.AddBankAccountOwnerController = class AddBankAccountOwnerController extends Controllers.BankAccountFormController {

        // @ngInject
        constructor($scope, $injector, $modalInstance, UsersManager, PhotosUploadManager, person, fromBankAccountForm, CompaniesManager, RegexService, AnalyticsService, $translate, _, Stripe, $q) {
            super($scope, $injector, $modalInstance, UsersManager, CompaniesManager);
            this.__objectType = 'EditPaymentReminderEmailController';
            this.PhotosUploadManager = PhotosUploadManager;
            this.AnalyticsService = AnalyticsService;
            this.Stripe = Stripe;
            this.$translate = $translate;
            this._ = _;
            this.$q = $q;
            this.fromBankAccountForm = fromBankAccountForm;
            this.infoLabel = 'COMPANY_SETTING.BANK_ACCOUNT.ACCOUNT_OWNER_MODAL.' + (fromBankAccountForm ? '_AFTER_BANK_ACCOUNT_FORM_' : '_MUST_BE_RELATED_');

            this.isEditMode = !!person;
            this.person = person;

            const { 
                VALID_SSN,
                VALID_SSI,
                VALID_ZIP,
                VALID_CANADAIAN_POSTAL_CODE,
                VALID_EMAIL,
            } = RegexService.PATTERNS;

            this.localSsnRegex = this.isCanada() ? VALID_SSI : VALID_SSN;
            this.ssnRegex = this.isEditMode ? /.*/ : this.localSsnRegex;
            this.ssnMinLength = this.isEditMode ? 4 : 9;

            this.zipRegex = this.isCanada() ? VALID_CANADAIAN_POSTAL_CODE : VALID_ZIP;
            this.emailRegex = VALID_EMAIL;

            this.currentUser = UsersManager.getCurrUser();
            this.company = this.currentUser.company;
            this.stripePersons = this.company.stripe_persons;
            this.bankAccount = this.currentUser.myBankAccount();
            this.showOwnershipField = !this.bankAccount ||
                                      !this.bankAccount.type ||
                                      this.bankAccount.type !== "Individual";

            this.shouldPrefill = this.company.stripe_persons && 
                                 this.company.stripe_persons.length === 0;
            this.lastError = null;

            this._init(person, this.bankAccount);
        }

        prefillOwner(owner, bankAccount) {
            if (!owner && this.shouldPrefill) {
                this.firstName = this.currentUser.first_name;
                this.lastName = this.currentUser.last_name;
                this.email = this.currentUser.email;
                this.phone = this.currentUser.phone_number;
                this.businessOwnership = DEFAULT_BUSINESS_OWNERSHIP;
                this.street = bankAccount.street_address;
                this.city = bankAccount.city;
                this.state = this.states.find(
                    state => state.abbreviation === bankAccount.state
                );

                // in case these fields were pre-filled we need to make sure to
                // add them to the dirty fields list
                this.preFilledFieldNames = [
                    "firstName",
                    "lastName",
                    "email", 
                    "phone", 
                    "businessOwnership", 
                    "street",
                    "city",
                    "state"
                ];
                return;
            } else if (!owner) {
                return;
            }

            this.firstName = owner.first_name;
            this.lastName = owner.last_name;
            this.birthDate = owner.date_of_birth;
            this.ssn = `*****${owner.ssn}`;
            
            this.businessOwnership = owner.ownership_percentage || DEFAULT_BUSINESS_OWNERSHIP;
            this.street = owner.street_address;
            this.city = owner.city;
            this.zip = owner.zip_code;
            this.state = this.states.find(
                state => state.abbreviation === owner.state
            );

            this.email = owner.email;
            this.phone = owner.phone_number;
            this.hasIdentificationFrontImage = owner.has_identification_front_image;
            this.hasIdentificationBackImage = owner.has_identification_back_image;
            this.jobTitle = owner.job_title;
        }

        getDirtyFieldNames() {
            const nonInputOrPrefilledDirtyFields = Object.keys(this.nonInputDirtyFieldNames).concat(
                this.preFilledFieldNames || []
            );

            return this.getFormDirtyFieldNames(
                this.addOwnerForm,
                nonInputOrPrefilledDirtyFields
            );
        }

        setNonInputDirtyField(name) {
            this.nonInputDirtyFieldNames[name] = true;
        }

        getFieldValue(name) {
            switch(name) {
                case 'state':
                    return this.state.abbreviation;
                case 'identificationBackImageUrl':
                    return this.identificationBackImageUrl;
                case 'identificationFrontImageUrl':
                    return this.identificationFrontImageUrl;
                default:
                    return this[name];
            }
        }

        isSubmitDisabled(form) {
            return this.requestInProgress;
        }

        submit() {
            this.lastError = null;
            this.addOwnerForm.$setSubmitted();
            this.AnalyticsService.trackClick(
                this, 
                'save bank account owner',
                { action: this.isEditMode ? 'update' : 'save'}
              );

            if (!this.isFormValid()) {
                this.AnalyticsService.track(
                    this,
                    "bank details owner modal - submitted with errors"
                );
                return;
            }

            this.requestInProgress = true;

            const changedFieldNames = this.getDirtyFieldNames();
            const data = changedFieldNames.reduce((acc, fieldName) => {
                acc[MAPPED_FIELD_NAMES[fieldName]] = this.getFieldValue(fieldName);
                return acc;
            }, {
                token_id: ''
            });

            data.country = this.company.country;

            // If SSN is dirty, get token from Stripe
            if (data.ssn) {
                this.getPersonToken().then((response) => {
                    if (response) {
                        if (response) {
                            data.token_id = response.token.id;
                            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.stripe_person_token_created);
                        }
                        this.submitData(data);
                    }
                })
                    .catch((response) => {
                        if (response && response.error && response.error.message) {
                            this.lastError = response.error.message;
                        }
                        else if (response && response.data && response.data.error_message) {
                            this.lastError = response.data.error_message;
                        }
                        else {
                            this.lastError = "An error has occurred. If the problem persists, please contact our support at concierge@honeybook.com";
                        }
                        this.lastError = this.lastError.replace('support@stripe.com', 'concierge@honeybook.com');
                        this.requestInProgress = false;

                        // Show internal error on Analytics if exists
                        var error_message = this.lastError;
                        if (response && response.message) {
                            error_message += response.message;
                        }
                        // Scroll to top
                        angular.element("#bank_account_owner_container").animate({scrollTop: 0}, 200);
                    });
            } else {
                this.submitData(data);
            }

        }

        submitData(data) {
            let promise = !this.isEditMode
                ? this.CompaniesManager
                      .addBankAccountOwner(this.user.company, data)
                      .then(() => this.AnalyticsService.track(this, "create bank account owner success"))
                : this.CompaniesManager
                      .updateBankAccountOwner(this.user.company, this.person._id, data)
                      .then(() => this.AnalyticsService.track(this, "update bank account owner success"));
            promise
                .then(this.close.bind(this))
                .catch((e) => {
                    if (e.data && e.data.error_type && (e.data.error_type === 'HBStripeUserError' || e.data.error_type === 'HBUserError')) {
                        this.lastError = e.data.error_message;
                    }
                    else if (e.data && e.data.error_type && (e.data.error_type === 'Rack::Timeout::RequestTimeoutException' || e.data.error_type === 'Rack::Timeout::Error')) {
                        this.AnalyticsService.track(this, "timeout adding an owner");
                        this.lastError = this.$translate.instant('ERRORS.SERVER_API._BACKEND_TIMEOUT_');
                    }
                    else {
                        this.lastError = this.$translate.instant('ERRORS.SERVER_API._UNEXPECTED_');
                    }
                    // scroll container to top so error message is visible
                    angular.element("#bank_account_owner_container")
                    .animate({scrollTop: 0}, 200);
                })
                .finally(() => this.requestInProgress = false);
        }

        getPersonToken() {
            var deferred = this.$q.defer();
            this.Stripe.then(stripeSdk => {
                var stripe = stripeSdk(this.user.stripe_key);
                stripe.createToken('pii', {
                    personal_id_number: this.ssn
                }).then(function(response) {
                    if (response.error) {
                        deferred.reject(response);
                        return;
                    }

                    deferred.resolve(response);
                }).catch(function (res) {
                    console.log(res);
                });
            });
            return deferred.promise;
        }

        onIdentificationFileSelected(file, side) {
            let imageFieldName = side === 'front' ?
             'identificationFrontImageUrl' :
             'identificationBackImageUrl';
            this.setNonInputDirtyField(imageFieldName);
            this.AnalyticsService.trackClick(
                this, 
                "upload id document", 
                {side}
            );

        }

        onIdentificationUploaded(url, side) {
            delete this.fieldsToFix["photo_id"];
            if (side === 'front') {
                this.identificationFrontImageUrl = url;
                this.hasIdentificationFrontImage = true;
            } else {
                this.identificationBackImageUrl = url;
                this.hasIdentificationBackImage = true;
            }
        }

        onDateKeyDown($event) {
            if ($event.keyCode !== 8 && $event.keyCode !== 46) {
                $event.preventDefault();
            }
        }

        onStateChange(stateOption) {
            this.setNonInputDirtyField("state");
            delete this.fieldsToFix["state"];
            this.state = stateOption;
        }

        isFormValid() {
            return this.addOwnerForm.$valid && this.state && this.hasIdentificationFrontImage && this._.isEmpty(this.fieldsToFix);
        }

        isValidDOB() {
            if (!this.birthDate) {
                return true;
            }

            const today = new Date();
            const minValidDate = new Date(today.setYear(today.getFullYear() - MIN_ALLOWED_AGE));
            const birthDate = new Date(this.birthDate);
            
            return birthDate < minValidDate;
        }

        getErrorMessage(fieldName, translationString) {
            if (this.fieldsToFix[fieldName]) {
                return 'COMPANY_SETTING.BANK_ACCOUNT.COMMON_MODAL._MISSING_INFO_ERROR_MESSAGE_';
            }

            return this.patternFieldErrorMessage(
                fieldName,
                'COMPANY_SETTING.BANK_ACCOUNT.ACCOUNT_OWNER_MODAL.' + translationString,
                this.addOwnerForm
            );
        }

        onSSNTooltipHover() {
            this.AnalyticsService.track(this, "bank details opened ssn tooltip");
        }

        onSsnBlur() {
            if (this.addOwnerForm.ssn.$dirty) {
                this.ssnRegex = this.localSsnRegex;
                this.ssnMinLength = 9;
            }
        }

        onBusinessOwnershipBlur() {
            this.addOwnerForm.businessOwnership.$setValidity('pattern', true);
            const filteredPersons = this.stripePersons.filter(p => p.email !== this.email);

            let totalOwnershipPercentage = filteredPersons.reduce(
                (acc, person) => acc + person.ownership_percentage,
            this.businessOwnership);


            if (totalOwnershipPercentage > 100) {
                this.addOwnerForm.businessOwnership.$setValidity('pattern', false);
            }
        }

        getBusinessOwnershipErrorMessage() {
            const $error = this.addOwnerForm.businessOwnership.$error;

            if (!$error) {
                return null;
            }

            if ($error.pattern) {
                return "COMPANY_SETTING.BANK_ACCOUNT.ACCOUNT_OWNER_MODAL._BUSINESS_OWNERSHIP_ERROR_";
            }

            if ($error.min) {
                return "COMPANY_SETTING.BANK_ACCOUNT.ACCOUNT_OWNER_MODAL._BUSINESS_OWNERSHIP_MIN_ERROR_";
            }

            if ($error.max) {
                return "COMPANY_SETTING.BANK_ACCOUNT.ACCOUNT_OWNER_MODAL._BUSINESS_OWNERSHIP_MAX_ERROR_";
            }

            return "FREQUENT_ERRORS._REQUIRED_";
        }

        shouldShowError(fieldName, customValidation = false) {
            const field = this.addOwnerForm[fieldName];
            const isFieldToFix = this.fieldsToFix[fieldName];
            const showError = this.addOwnerForm.$submitted || (field && field.$touched) || isFieldToFix;

            if (customValidation) {
                return showError;
            }

            return showError && (field && (field.$invalid || isFieldToFix));
        }

        onFieldFocus(fieldName) {
            if (this.fieldsToFix[fieldName]) {
                delete this.fieldsToFix[fieldName];
            }
        }

        shouldShowAllFieldsReqError() {
            return this.addOwnerForm.$submitted &&
                    (!this.addOwnerForm.$valid || 
                     !this._.isEmpty(this.fieldsToFix)
                    );
        }

        _init(owner = null, bankAccount = {}) {
            this.prefillOwner(owner, bankAccount);
            this.initFieldsToFix(owner);
        }
    };

}());